import produce from 'immer';

import { IMigrationScript } from '../../../utils/prepareWidgetblockMigrationScripts';
import { DataTableConfigBlockState } from '../types';

const addHeaderPadding: IMigrationScript<DataTableConfigBlockState> = (state) =>
    produce(state, (draft) => {
        draft.settings.headerPadding = 15;
    });

export default addHeaderPadding;
